<template>
  <div class="record">
    <el-row style="margin: 10px">
      <el-col :span="3">
        <!-- <el-link style="font-size: 16px" icon="el-icon-download" href="http://adore.nat300.top/record/export" target="_blank">导出配置文件</el-link> -->
        <!-- <el-link style="font-size: 16px" icon="el-icon-download" :href="`${axios.defaults.baseURL}/export/json`" target="_blank">导出配置文件</el-link> -->
        <el-button type="text" size="small" @click="downloadConfig">导出配置文件</el-button>
      </el-col>
      <el-col :span="3">
        <el-button type="text" size="small" @click="downloadExcel">导出参数文件</el-button>
        <!-- <el-link style="font-size: 16px" icon="el-icon-download" :href="`${axios.defaults.baseURL}/export/excel`" target="_blank">导出参数文件</el-link> -->
      </el-col>
    </el-row>
    <!-- 表格 -->
    <div style="font-size: 18px;color: #303133;line-height: 24px; font-weight: bolder">参数集列表</div>
    <el-row style="margin: 10px">
      <el-col :span="24">
        <el-table :data="recordList" style="width: 100%" border max-height="520">
          <el-table-column align="center" prop="name" label="英文名称"></el-table-column>
          <!-- <el-table-column align="center" prop="chineseName" label="中文名称"></el-table-column> -->
          <el-table-column align="center" prop="describe" label="功能说明(英)" width="350"></el-table-column>
          <el-table-column align="center" prop="chineseDescribe" label="功能说明(中)" width="350"></el-table-column>
          <el-table-column align="center" prop="paramCount" label="参数个数"></el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="160">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="goDetail(scope.row.id)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 分页插件 -->
    <el-row>
      <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage" :page-sizes="[10, 30, 50]" :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next" :total="pageInfo.total"></el-pagination>
    </el-row>
  </div>
</template>

<script>
// console.log(this.axios.defaults.baseURL)
import router from '@/router'
import { Loading } from 'element-ui'

export default {
  data() {
    return {
      recordList: [],
      pageInfo: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted: function () {
    this.findAll(this.pageInfo.currentPage, this.pageInfo.pageSize)
  },
  methods: {
    findAll(current, size) {
      this.axios.get('/record', {
        params: {
          current: current,
          size: size
        }
      })
        .then(res => {
          this.pageInfo = {
            currentPage: res.data.current,
            pageSize: res.data.size,
            total: res.data.total
          }
          this.recordList = res.data.records
        })
    },
    handleSizeChange(val) {
      this.findAll(1, val)
    },
    handleCurrentChange(val) {
      this.findAll(val, this.pageInfo.pageSize)
    },
    goDetail(id) {
      router.push({ path: '/params/record-detail', query: { id: id } })
    },
    downloadConfig() {
      const loading = Loading.service({
        text: '正在下载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.axios({
        method: 'get',
        url: `${this.axios.defaults.baseURL}/export/json`,
        responseType: 'blob'
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', 'records.json')
        document.body.appendChild(link)
        link.click()
        loading.close()
      })
    },
    downloadExcel() {
      const loading = Loading.service({
        text: '正在下载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.axios({
        method: 'get',
        url: `${this.axios.defaults.baseURL}/export/excel`,
        responseType: 'blob'
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', 'adore.xlsx')
        document.body.appendChild(link)
        link.click()
        loading.close()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.pagination {
  display: flex;
  justify-content: flex-end;
}

.form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
